export const KEY_TO_HANDLER = {
  website: 'website',
  twitter: 'twitter',
  linkedinHandle: 'linkedin',
  telegramHandler: 'telegram',
  blog: 'blog',
  blueskyHandler: 'bluesky',
  crunchbaseHandler: 'crunchbase',
};
